import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { UsersComponent } from "../../components/users"

export const UsersPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <UsersComponent />
    </DefaultPageComp>
  </>
}